

import { useState } from "react"
import { NavLink } from 'react-router-dom'
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { CalendarDays, Settings, Moon, Sun, Download, Bell, Activity, Image } from "lucide-react"
import { useTheme } from "next-themes"

export function TopNavigation() {
  const { theme, setTheme } = useTheme()
  const [activeAlerts] = useState(3)
  

  return (
    <header className="border-b bg-card/50 backdrop-blur supports-[backdrop-filter]:bg-card/50">
      <div className="flex h-16 items-center justify-between px-6">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-3">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Activity className="h-5 w-5" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-foreground">FloodIQ</h1>
              <p className="text-xs text-muted-foreground">Flood Analytics Platform</p>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-1">
            {/* <Button 
              variant={currentPage === "dashboard" ? "default" : "ghost"} 
              size="sm" 
              onClick={() => onPageChange?.('dashboard')}
            >
              Overview
            </Button> */}
            <NavLink to="/map" end>
              {({ isActive }) => (
                <Button variant={isActive ? 'default' : 'ghost'} size="sm">
                  Map Explorer
                </Button>
              )}
            </NavLink>
            <NavLink to="/flood-events">
              {({ isActive }) => (
                <Button variant={isActive ? 'default' : 'ghost'} size="sm">
                  <Image className="mr-2 h-4 w-4" />
                  Flood Events
                </Button>
              )}
            </NavLink>
            {/* <Button 
              variant={currentPage === "assets" ? "default" : "ghost"} 
              size="sm"
              onClick={() => onPageChange?.('assets')}
            >
              Assets
            </Button>
            <Button 
              variant={currentPage === "scenarios" ? "default" : "ghost"} 
              size="sm"
              onClick={() => onPageChange?.('scenarios')}
            >
              Scenarios
            </Button>
            <Button 
              variant={currentPage === "early-warning" ? "default" : "ghost"} 
              size="sm"
              onClick={() => onPageChange?.('early-warning')}
            >
              Early Warning
            </Button>
            <Button 
              variant={currentPage === "downloads" ? "default" : "ghost"} 
              size="sm"
              onClick={() => onPageChange?.('downloads')}
            >
              Downloads
            </Button> */}
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <Button variant="outline" size="sm" className="gap-2 bg-transparent">
            <CalendarDays className="h-4 w-4" />
            Last 30 days
          </Button>

          <Button 
            variant="outline" 
            size="sm" 
            className="relative bg-transparent"
          >
            <Bell className="h-4 w-4" />
            {activeAlerts > 0 && (
              <Badge variant="destructive" className="absolute -right-2 -top-2 h-5 w-5 rounded-full p-0 text-xs">
                {activeAlerts}
              </Badge>
            )}
          </Button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm">
                <Settings className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => setTheme(theme === "dark" ? "light" : "dark")}>
                {theme === "dark" ? (
                  <>
                    <Sun className="mr-2 h-4 w-4" />
                    Light mode
                  </>
                ) : (
                  <>
                    <Moon className="mr-2 h-4 w-4" />
                    Dark mode
                  </>
                )}
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Download className="mr-2 h-4 w-4" />
                Export settings
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  )
}
